module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e8ymi"))).then(() => parcelRequire('8rm4T'));